export default __webpack_public_path__ + "static/media/KneeFlexionAtMidstance.3cd4492a.png";